import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { deaValidationRegex, US_States_Big } from '../../models/constants';
import { Landing } from '../../models/landing';
import { AppInfoService } from '../../services/app-info.service';
import { LicenseService } from '../../services/user/license.service';
import { UserService } from '../../services/user/user.service';

@Component({
  selector: 'app-medprodid',
  templateUrl: './medprodid.component.html',
  styleUrls: ['./medprodid.component.scss'],
})
export class MedprodidComponent implements OnInit {
  @Output() onMedprodDataRecieved = new EventEmitter<any>();
  @Input() regDetails = true;

  errorSearchMessage: string;
  subs: Subscription = new Subscription();
  license: any = {
    number: '',
    state: '',
    type: '',
    user: {
      first_name: '',
      last_name: '',
      phone: '',
      email: '',
      company: '',
    },
  };
  userData: any;

  deaButtonOptions: any = {
    text: 'Search',
    type: 'default',
    icon: 'search',
    useSubmitBehavior: true,
    disabled: false,
  };

  loadingVisible = false;

  states = US_States_Big;

  searchExprOption = ['name', 'abbreviation'];

  landingConfigs: Landing;
  client = null;

  constructor(
    private licenseService: LicenseService,
    public appInfo: AppInfoService,
    public userService: UserService,
  ) {}

  ngOnInit() {
    this.getLandingInfo();
    this.getMsClient();

    //Gets registered user info for email templates if not a new registration
    if (!this.regDetails) {
      this.getMe();
    }
  }

  getMsClient() {
    this.userService
      .getMsClient$()
      .subscribe(result => (this.client = result.data));
  }

  getLandingInfo() {
    this.appInfo.get().subscribe(result => (this.landingConfigs = result));
  }

  onDeaSubmit(e) {
    this.errorSearchMessage = '';
    this.loadingVisible = true;
    if (this.isDeaNumber(this.license.number)) {
      this.license.type = 'dea_license';
    } else {
      this.license.type = 'state_license';
    }
    this.searchByLicense(this.license);
    e.preventDefault();
  }

  getMe() {
    this.userService.getMe().subscribe(result => {
      this.license.user.first_name = result.data.first_name;
      this.license.user.last_name = result.data.last_name;
      this.license.user.phone = result.data.phone;
      this.license.user.email = result.data.email;
      this.license.user.company = result.data.company;
    });
  }

  isDeaNumber(deaNumber): boolean {
    if (deaValidationRegex.test(deaNumber)) {
      return this.isValidDea(deaNumber);
    }
    return false;
  }

  isValidDea(deaNumber) {
    const even =
      (Number(deaNumber[3]) + Number(deaNumber[5]) + Number(deaNumber[7])) * 2;
    const odd =
      Number(deaNumber[2]) + Number(deaNumber[4]) + Number(deaNumber[6]);
    const sum = even + odd;
    const lastDigit = sum % 10;
    return lastDigit === Number(deaNumber[8]);
  }

  searchByLicense(license) {
    const apiCall = this.licenseService.searchLicense(license);
    this.makeMedProdCall(apiCall);
  }

  makeMedProdCall(apiCall) {
    const s = apiCall
      .subscribe(
        result => this.checkAndEmittMedprodData(result),
        error => this.handlMedprodError(error),
      )
      .add(() => (this.loadingVisible = false));
    this.subs.add(s);
  }

  checkAndEmittMedprodData(result) {
    const hasDeaData = result.data.dea && result.data.dea_expiry;
    const hasStateLicenseData = result.data.sl && result.data.sl_expiry;

    if (!hasDeaData && !hasStateLicenseData) {
      this.handlMedprodError();
    } else {
      result['data']['user'] = this.license.user;
      this.onMedprodDataRecieved.next(result.data);
    }
  }

  handlMedprodError(error = null) {
    this.onMedprodDataRecieved.next(null);
    this.errorSearchMessage = error
      ? error.error
        ? error.error
        : 'Not Found'
      : 'Matching state license or DEA number was not found';
  }
}
